import { render } from "./TalentAccountSection.vue?vue&type=template&id=7ba8c8a2"
import script from "./TalentAccountSection.vue?vue&type=script&lang=js"
export * from "./TalentAccountSection.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./TalentAccountSection.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__